// ABOUTME: Calls back once a UTC day boundary has passed — by a timer armed at the next midnight
// ABOUTME: UTC plus a second, and by the same check when the tab comes back to the foreground.
import { useEffect, useEffectEvent } from "react"
import { watchDayBoundary, type DayClock } from "./dayBoundary"

const DAY_MS = 24 * 60 * 60 * 1000

/**
 * A second past midnight, not midnight: the server compares the row's date
 * with its own clock as UTC midnight, and at a zero difference it still
 * answers "not yet visible".
 */
export const UTC_MIDNIGHT_MARGIN_MS = 1000

const UTC_CLOCK: DayClock = {
  dayOf: (now) => Math.floor(now / DAY_MS),
  untilNextMidnight: (now) => DAY_MS - (now % DAY_MS),
  marginMs: UTC_MIDNIGHT_MARGIN_MS,
}

/** Why a timer and a visibility check, and what the jitter spreads: watchDayBoundary. */
export function useUtcDayChange(onDayChange: () => void, jitterMs = 0): void {
  const notifyDayChange = useEffectEvent(onDayChange)

  useEffect(() => watchDayBoundary(UTC_CLOCK, () => notifyDayChange(), jitterMs), [jitterMs])
}
